import type React from 'react';

import { LegacyGooglePlacesProvider } from '#src/app/shared/hooks/googlePlaces';

import { PlaceField } from './PlaceField';
import type { PlaceFieldProps } from './PlaceField';

export const PlaceFieldWrapper: React.FC<PlaceFieldProps> = (props) => {
	return (
		<LegacyGooglePlacesProvider>
			<PlaceField {...props} />
		</LegacyGooglePlacesProvider>
	);
};
